import settings from '~/settings';
import { ROUTES_MAP, ROUTES_PROGRESS_TYPES } from '~/router/routes';

import type { ProgressModel } from './types';
import type { RouteObject } from 'react-router-dom';
import type { NavigationContext } from '~/store/selectors/navigationSelectors';
import type { ICurrentAccountState } from '~/store/slices/currentAccountSlice';

const clamp01 = (v: number) => {
  if (v < 0) {
    return 0;
  }
  if (v > 1) {
    return 1;
  }
  return v;
};

const shouldShowProfileProgress = (route: RouteObject, account: ICurrentAccountState) => {
  if (route.path !== ROUTES_MAP.PROFILE) {
    return false;
  }

  return Boolean(
    settings.supply.isEnabled && account.leveling && account.accumulativeClanResource && !account.isBonusActivated,
  );
};

/**
 * Gets progress model for route + account
 */
export const getProgressModel = (route: RouteObject, navigationContext: NavigationContext): ProgressModel => {
  const { currentAccount } = navigationContext;

  if (
    !shouldShowProfileProgress(route, currentAccount) ||
    currentAccount.leveling === null ||
    currentAccount.accumulativeClanResource === null
  ) {
    return { kind: ROUTES_PROGRESS_TYPES.NONE };
  }

  const title = route.handle?.title?.(navigationContext) ?? '';

  const total = settings.supply.clanLevelingToAccountLeveling[currentAccount.leveling];
  const current = currentAccount.accumulativeClanResource;

  const completedRaw = total ? current / total : 0;

  return {
    kind: ROUTES_PROGRESS_TYPES.PROFILE_SUPPLY,
    title,
    completed: clamp01(completedRaw),
    current,
    total,
  };
};
